import { useContext } from 'react';
import { upcomingMeetingsContext } from './upcoming-meetings.context';

export const useUpcomingMeetings = () => {
  const { store } = useContext(upcomingMeetingsContext);
  const {
    updateAccounts,
    isFetching,
    events,
    searchTerm,
    meetingType,
    pageSize,
    page,
    paginationMetadata,
    mType,
    canLoadData,
    participants,
    meetingTypeChanged,
    resetFilters,
    updateAccountsFiltered,
    searchTermChanged,
    pageChanged,
    keepFetching,
    refetch,
    setPurposeStatement,
    updateMeetingAccount,
    updateMType,
    saveFiltersView,
    setCurrentFilterView,
    setParticipants,
  } = store();

  return {
    isFetching,
    updateAccounts,
    events,
    pageSize,
    page,
    searchTerm,
    paginationMetadata,
    meetingType,
    mType,
    hasNextPage: paginationMetadata.page < paginationMetadata.totalPages,
    canLoadData,
    participants,
    setParticipants,
    meetingTypeChanged,
    updateAccountsFiltered,
    changeSearchTerm: searchTermChanged,
    changePage: pageChanged,
    resetFilters,
    keepFetching,
    refetch,
    setPurposeStatement,
    updateMeetingAccount,
    updateMType,
    saveFiltersView,
    setCurrentFilterView,
  };
};
